import { DocRender } from 'react-doc-render';
import React from "react";

interface DocxViewerProps {
    src: string;
}

const DocxViewer: React.FC<DocxViewerProps> = ({ src }) => {
    return (
        <div
            className="relative max-w-[1000px] max-h-[90vh] bg-neutral-400 dark:bg-neutral-800 rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
            style={{
                width: '90vw',
                height: '90vh'
            }}
        >
            <DocRender
                uri={src}
                className="w-[95%] h-[95%] mx-auto my-5 overflow-auto p-4 bg-white rounded-md"
                style={{ position: 'relative', zIndex: 1 }}
            />
        </div>
    );
};

export default DocxViewer;